import { render, staticRenderFns } from "./ListItemStatus.vue?vue&type=template&id=3becd9d6&"
import script from "./ListItemStatus.vue?vue&type=script&lang=ts&"
export * from "./ListItemStatus.vue?vue&type=script&lang=ts&"
import style0 from "./ListItemStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports